import { axiosInstance } from "./axios";

export const fetchMemberList = async (id: string) => {
    try {
        return await axiosInstance.post(`/event/${id}/collaborators`, { search: ""});
    } catch (error) {
        throw error;
    }
};

export const fetchTaskList = async (payload: any) => {
    try {
        return await axiosInstance.get(`/event/${payload.eventId}/get-task-list/${payload.block_id}/${payload.card_id}`);
    } catch (error) {
        throw error;
    }
}

export const updateTaskService = async (eventId: string, payload: any) => {
    try {
        return await axiosInstance.put(`/event/${eventId}/update-task`, payload);
    } catch (error) {
        throw error;
    }
}

export const getChipsData = async (card_id: string) => {
    try {
        return await axiosInstance.get(`/event/card-chips/${card_id}`);
    } catch (error) {
        throw error;
    }
}

export const updateCardStatus = async (eventId: string, payload: any) => {
    try {
        return await axiosInstance.put(`/event/${eventId}/update-card-status`, payload);
    } catch (error) {
        throw error;
    }
}